// Shared Data - Common information used across multiple sections
export const sharedData = {
  personal: {
    name: "Rasheed Abu Khader",
    image: {
      src: require('../assets/me2.jpg'),
      alt: "Rasheed Abu Khader"
    }
  },
  
  socialLinks: {
    linkedin: 'https://www.linkedin.com/in/rasheed-abu-khader-92a4441b5/',
    github: 'https://github.com/rabukhader',
    instagram: 'https://www.instagram.com/rasheed_abu_khader/',
    facebook: 'https://www.facebook.com/rasheed.abukhader.5/',
    twitter: 'https://twitter.com/Rasheed_imad'
  },
  
  contact: {
    email: 'rasheedabukhader123@gmail.com',
    phone: '+972592844743'
  }
};
